import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { walletService, type EditWalletBalancePayload } from '@/api/services/walletService'

export function useWalletStudents(p: { wallet_filter?: string; search?: string; page?: number; limit?: number }) {
  return useQuery({
    queryKey: ['wallet-students', p],
    queryFn: () => walletService.listStudents(p),
    staleTime: 15_000,
  })
}

export function useEditWalletBalance() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: EditWalletBalancePayload) => walletService.editBalance(data),
    onSuccess: (_, variables) => {
      qc.invalidateQueries({ queryKey: ['wallet-students'] })
      qc.invalidateQueries({ queryKey: ['users'] })
      qc.invalidateQueries({ queryKey: ['wallet-history', variables.user_id] })
    },
  })
}

export function useWalletHistory(userId?: number, enabled = true) {
  return useQuery({
    queryKey: ['wallet-history', userId],
    queryFn: () => walletService.editHistory({ user_id: userId! }),
    enabled: !!userId && enabled,
    staleTime: 15_000,
  })
}
